import util from '@/libs/util'

const post = util.ajax.post

export const userUrls = [
  // 查询
  '/accountUser/list'
]

export const user = {}

user.listUser = function (params) {
  return post('/accountUser/list', params)
}
user.editPassword = function (params) {
  return post('/api/member/change-pwd', params)
}
user.storeDetail = function (id) {
  return post(`/organ/detail?storeId=${id}`)
}



// WEBPACK FOOTER //
// ./src/api/gip/account/user.js